<!--
 * @Description:
 * @Author: JDY
 * @Date: 2021-04-07 12:00:03
 * @LastEditTime: 2021-05-10 10:40:47
 * @LastEditors: JDY
-->
<template>
  <a-form :form="form">
    <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
      <a-radio-group
        name="state"
        v-decorator="[
          'state',
          {
            rules: [{ required: true, message: '选择发票状态' }]
          }
        ]"
      >
        <a-radio :value="1">
          待开票
        </a-radio>
        <a-radio :value="2">
          开票中
        </a-radio>
        <a-radio :value="3">
          已开票
        </a-radio>
      </a-radio-group>
    </a-form-item>
  </a-form>
</template>

<script>
import { requestPut } from '@/api/api'

export default {
    name: 'ModelForm',
    props: {
        aid: {
            type: [Array, Object],
            required: true
        }
    },
    components: {},
    data () {
        return {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 7 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 13 }
            },
            form: this.$form.createForm(this)
        }
    },
    mounted () {},
    methods: {
        onOk () {
            const {
                form: { validateFields }
            } = this
            return new Promise(resolve => {
                // 回调resolve(true)关闭弹出层
                validateFields((errors, values) => {
                    if (!errors) {
                        values.id = this.$props.aid
                        requestPut('/finances/invoices', values)
                            .then(res => {
                                this.$notification.success({
                                    message: res.msg
                                })
                                resolve(true) // 关闭弹出层
                            })
                            .catch(err => console.log(err))
                    }
                })
            })
        },
        onCancel () {
            return new Promise(resolve => {
                resolve(true)
            })
        }
    }
}
</script>
